import type { ReactNode } from "react";
import { useOfflineContext } from "~contexts/OfflineContext/useOfflineContext";
import { classList } from "~lib/classList";
import styles from "./AccountSummarySlide.module.scss";
import { OfflineNotice } from "./OfflineNotice";
import { SlideHeading } from "./SlideHeading";

type AccountSummarySlideProps = {
  heading?: ReactNode;
  children: ReactNode;
};

export function AccountSummarySlide({
  heading,
  children,
}: AccountSummarySlideProps) {
  const { isOffline } = useOfflineContext();

  return (
    <div>
      {heading && <SlideHeading>{heading}</SlideHeading>}
      <div className={classList(styles.cards, isOffline && styles.disabled)}>
        {children}
      </div>
      {isOffline && <OfflineNotice />}
    </div>
  );
}
